export default __webpack_public_path__ + "static/media/modesp01.97f95c38.png";